<ng-container *ngIf="showEmail">
    <div class="container" style="text-align: justify; background: transparent !important; margin-top: -9px;">
        <div class="d-flex justify-content-between">
            <div>
                <h4 class="text-center_second float-left getstartedtext">Get started</h4>
            </div>
            <div style="margin-top: 17px;">
                <img src="../../../assets/img/close.svg" alt="" (click)="closeModal();close_popup()" style="cursor: pointer;">
            </div>
        </div>
        <form [formGroup]="getOtpForm" autocomplete="off">
            <div class="input-group">
                <input id="fileInput" type='Email' formControlName="userEmail" name="email" autocomplete="off"
                    placeholder="Enter your Email" style="width: 68% !important;">
                <span class="input-group-btn">
                    <button class="btn-getotp" (click)="sendOtpByEmail()">Get OTP</button>
                </span>
            </div>

            <mat-chip-list aria-label="Fish selection">
                <div *ngIf="f.userEmail.touched && f.userEmail.invalid && !submitted" class="text-danger">
                    <div *ngIf="f.userEmail.errors && f.userEmail.errors.required">
                        <mat-chip>Please enter valid email
                        </mat-chip>
                    </div>
                </div>

                <span class="text-danger" *ngIf="!getOtpForm.controls.userEmail.valid && submitted">
                    <mat-chip>Please enter valid email
                    </mat-chip>
                </span>
            </mat-chip-list>
        </form>

        <div class="or"> or</div>

        <div class="d-flex space-even">
            <!-- <div>
                <img src="../../../assets/img/google-icon.svg" alt="" class="social-login-icon" (click)="signInWithGoogle()">
            </div> -->
            <!-- google(icon) button using new way of login -->
            <div id="googleLoginIcon"></div>
            <div>
                <img src="../../../assets/img/facebook-icon.svg" alt="" class="social-login-icon" (click)="signInWithFB()">
            </div>
        </div>

        <div class="term_text" align="center">
            <p> By continuing, I agree to the <span (click)="terms()">terms of use <span style="color: black !important;">and &nbsp;</span>
                </span> <span (click)="Privacy()">privacy policy</span> </p>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="!showEmail && !showNameScreen">
    <div class="container">
        <h4 class="text-center_second float-left">Verify with OTP</h4>
        <div>
            <p class="form_text mail_stored float-left">Sent via Mail to {{userEmailStored}}</p>
        </div>

        <form novalidate class="form_field float-left">
            <div class="col-12">
                <ng-otp-input (onInputChange)="onOtpChange($event)" [config]="{length:4,allowNumbersOnly:true}">
                </ng-otp-input>
            </div>
            <div *ngIf="showErrorMessage" class="invalidOTP">Invalid OTP</div>
        </form>


        <div class="col-12" class="form_text float-left">
            <!-- <p>
                Typing to auto-fill OTP <strong>00:12</strong>
            </p> -->
            <p>
                Didn't receive an OTP ? <span><a (click)="resendOtp()">RESEND</a></span>
            </p>
        </div>
        <br>
    </div>
</ng-container>



<style>
    .text-center {
        margin-bottom: 10px !important;
        font-size: 25px;
        font-family: helvetica nue;
        color: gray;
    }

    .text-center_second {
        margin-bottom: 10px !important;
        font-size: 18px;
        color: #463f3f;
    }

    .form_text {
        margin-bottom: 10px !important;
        font-size: 16px !important;
        /* font-family: helvetica nue; */
        color: gray;
        line-height: 2.3;
    }

    .form_text p span {
        color: #278e1b !important;
    }

    .form_field {
        font-size: 16px !important;
        font-family: helvetica nue;
    }

    .term_text span {
        font-size: 12px;
        color: #479943 !important;
        font-family: 'Roboto';

    }

    .term_text {
        padding-top: 15px;
    }

    .term_text p {
        font-size: 12px;
        font-family: 'Roboto';
        text-align: justify;
        /* width: 102%; */
    }

    button {
        background-color: #479943;
        color: #ffff;
        justify-content: center;
        align-items: center;

    }

    @media only screen and (min-width: 600px) {
        .container {
            width: 424px;
            max-width: 100%;

        }

    }

    .container {
        position: relative;
        margin-left: auto;
        margin-right: auto;
        padding-right: 11px;
        padding-left: 11px;
        margin-top: -10px;
    }

    /* .container p{
                font-size: 13px;
                font-family: helvetica nue;
            } */
    .imagecookie {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        overflow: hidden;
        position: absolute;
        top: -30px;
        left: calc(50% - 50px);
        margin-left: 20px;
    }

    ::ng-deep .mat-bottom-sheet-container {
        padding: 8px 16px;
        min-width: 100vw;
        /* min-width: 512px;
  max-width: calc(100vw - 256px) !important; */
        box-sizing: border-box;
        display: block;
        outline: 0;
        overflow: auto;
        border-top-left-radius: 16px !important;
        border-top-right-radius: 16px !important;
    }

    ::ng-deep.mat-bottom-sheet-container-large {
        min-width: 380px;
        /* max-width: calc(51vw - 255px);  */
        max-width: 380px;
    }

    ::ng-deep.mat-bottom-sheet-container-xlarge {
        min-width: 380px !important;
        max-width: 380px;
    }

    /* @media only screen and (max-width: 1365px) {
        ::ng-deep .mat-bottom-sheet-container-large {
            min-width: 340px;
            max-width: calc(52vw - 255px);
        }

    } */


    .actions button {
        /* background-image: linear-gradient(to right, #62AF55, #4AB07F);
         */
        background: linear-gradient(to right, #62AF55, #4AB07F);
        font-family: helvetica nue;
        height: 30px;
        width: 230px;
        color: #ffff;
        font-weight: 600;
        margin: 9px;
    }

    .btn-getotp {
        background: linear-gradient(to right, #62AF55, #4AB07F);
        font-family: 'Roboto';
        height: 40px;
        color: #ffffff;
        font-weight: 600;
        font-size: 16px;
        letter-spacing: 0.8px;
        border: none;
        border-radius: 0px 5px 5px 0px;
        width: 95px;
    }

    .btn-getotp-next {
        background: linear-gradient(to right, #62AF55, #4AB07F);
        font-family: 'Roboto';
        height: 40px;
        color: #ffff;
        font-weight: 600;
        font-size: 16px;
        letter-spacing: 0.8px;
        border: none;
        border-radius: 0px 5px 5px 0px;
        width: 95px;
        line-height: 19px;
    }

    button[disabled] {
        opacity: 0.9;
        cursor: not-allowed !important;
    }

    .getstartedtext {
        font-family: 'Roboto';
        font-size: 18px;
        letter-spacing: 0.04px;
        line-height: 23px;
        font-weight: 450;
    }

    .actions img {
        margin: 10px !important;
    }

    .actions p {
        margin-top: 9px;
        text-align: center;
        font-size: 14px;
        color: #479943 !important;
        font-family: helvetica nue;
    }

    .actions_span {
        padding: 10px !important;
        color: gray;
    }

    #fileInput {
        align-items: center;
        background: #ebebeb;
        border: 1px solid #ebebeb;
        /* margin-top: 20px; */
        cursor: text;
        display: flex;
        font-family: 'Roboto';
        height: 40px !important;
        outline: none;
        padding: 0 1.42857143rem;
        padding: 0 calc(1.42857143rem - .2em);
        position: relative;
        transition: background 0.2s ease-in-out, border 0.2s ease-in-out, box-shadow 0.2s ease-in-out, color 0.2s ease-in-out;
        will-change: background, border, box-shadow, color;
        width: 75%;
        border-radius: 5px 0px 0px 5px;
        caret-color: #25cb7d;
    }

    :host ::ng-deep .otp-input {
        height: 60px !important;
        width: 60px !important;
    }

    .mail_stored {
        width: 367px;
    }

    .invalidOTP {
        color: #FA4747;
        margin-left: 10px;
    }

    ::ng-deep.otp-input:focus-visible {
        outline: 1px solid #25cb7d !important;
    }

    ::ng-deep.otp-input {
        border: 1px solid #25cb7d !important;
        border-radius: 8px !important;
    }
    .space-even {
        justify-content: space-evenly;
        width: 70%;
        margin: auto;
    }
    .or {
        display: flex;
        justify-content: center;
        padding: 10px 0px 10px 0px;
        color: #3C3C3C;
        font-size: 14px;
        line-height: 16px;
    }
    .social-login-icon {
        cursor: pointer;
    }
</style>